import { IModel } from '@/@types/models/model';
import coreFields from '../helpers/coreFields';

const Groblja: IModel = {
  title: 'Groblja',
  apiPath: 'groblja',
  layer: 'groblja',
  forms: {
    default: {
      fields: [
        'naziv',
        'status_id'
      ],
    },
  },
  listViews: {
    default: {
      fields: [
        'id',
        'naziv',
        'status_id',
        'docs'
      ],
      hidden: ['id'],
    },
  },
  fields: [
    coreFields.id,
    {
      title: 'naziv',
      source: 'naziv',
      ttoken: 'groblja:groblja.naziv',
      type: 'text',
      filter: true,
    },
    {
      title: 'status_id',
      source: 'status_id',
      ttoken: 'groblja:groblja.status',
      type: 'picker',
      subModel: {
        apiPath: 'groblja/statusi',
        format: '{label}',
        idattr: 'id',
      },
      filter: true,
    },
    coreFields.docs,
    coreFields.geom,
    coreFields.gid,
    coreFields.docs,
    coreFields.created_by,
    coreFields.created_on,
    coreFields.modified_by,
    coreFields.modified_on,
  ],
};

export default Groblja;
